import { Component, ErrorHandler, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavService, UxService } from '~/app/core/services';
import { IBreadcrumbHandler } from '~/app/open-age/core/services/breadcrumb-handler.interface';
import { IContextMenuHandler } from '~/app/open-age/core/services/context-menu-handler.interface';
import { IEntityHandler } from '~/app/open-age/core/services/entity-handler.interface';
import { ITitleHandler } from '~/app/open-age/core/services/title-handler.interface';
import { DetailBase } from '~/app/open-age/core/structures';
import { Employee } from '~/app/open-age/directory/models';
import { EmployeeService } from '~/app/open-age/directory/services';

@Component({
  selector: 'directory-employee-summary',
  templateUrl: './employee-summary.component.html',
  styleUrls: ['./employee-summary.component.css']
})
export class EmployeeSummaryComponent extends DetailBase<Employee> implements OnInit, OnChanges {

  @Input()
  code: string;

  constructor(
    api: EmployeeService,
    private uxService: UxService

  ) {
    super({ api, errorHandler: uxService });
  }
  ngOnChanges(): void {
    this.get(this.code);

  }
  ngOnInit(): void {
  }

}
